// services/apiClient.js

import axios from 'axios';
import configrations from '../config/configrations';

const API_URL = configrations.backendBaseUrl;

const apiClient = axios.create({
  baseURL: API_URL,
});

// Attach token automatically
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default apiClient;
